/* LSL · Collections : menu des filtres (colonne de gauche, tiroir sur mobile) plus simple à utiliser.
   Le formulaire d'origine (sections/lsl-c-main.liquid) et son script (lsl-collection-da.js) restent : on ajoute seulement
   - en tête : nombre de filtres actifs, « Tout effacer » et les filtres choisis en pastilles (un clic les retire) ;
   - des rubriques repliables avec le nombre de choix cochés ;
   - « Ton utilisation » en pastilles, « Ton personnage » avec une recherche, « Disponibilité » en interrupteur, des tranches de prix toutes prêtes ;
   - sur ordinateur, les résultats se mettent à jour dès qu'on coche (plus besoin de « Voir les résultats »), et la page revient sur la liste. */
(() => {
  'use strict';
  const panel = document.querySelector('.c-filters');
  const form = panel && panel.querySelector('form');
  if (!form || panel.classList.contains('lsl-cf')) return;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = t => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const norm = t => String(t).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  const desk = () => matchMedia('(min-width: 1100px)').matches;
  const store = (() => { try { return window.sessionStorage; } catch (_) { return null; } })();
  const KEY = 'lslCf';
  panel.classList.add('lsl-cf');

  /* Retour sur la liste après la mise à jour */
  try {
    if (store && store.getItem(KEY + 'Jump')) {
      store.removeItem(KEY + 'Jump');
      const lay = $('.c-layout');
      const go = () => { if (lay && lay.getBoundingClientRect().top > 120) window.scrollTo({ top: lay.getBoundingClientRect().top + window.scrollY - 96, behavior: 'auto' }); };
      if (lay) { requestAnimationFrame(go); setTimeout(go, 350); window.addEventListener('load', () => setTimeout(go, 50), { once: true }); }
    }
  } catch (_) {}

  const clear = $('.c-clear', form);
  const price = { gte: $('input[name="filter.v.price.gte"]', form), lte: $('input[name="filter.v.price.lte"]', form) };

  /* En-tête */
  const head = document.createElement('div');
  head.className = 'lsl-cf__head';
  head.innerHTML = `<p class="lsl-cf__ttl">Filtres<b data-lsl-cf-n hidden></b></p>${clear ? `<a class="lsl-cf__clear" href="${esc(clear.getAttribute('href'))}" hidden>Tout effacer</a>` : ''}`;
  const active = document.createElement('div');
  active.className = 'lsl-cf__active';
  active.setAttribute('aria-label', 'Filtres choisis');
  form.before(head, active);

  /* Envoi : sur ordinateur, dès qu'on change un filtre */
  let timer = 0;
  const apply = () => {
    clearTimeout(timer);
    panel.classList.add('is-busy');
    try { if (store) store.setItem(KEY + 'Jump', '1'); } catch (_) {}
    if (form.requestSubmit) form.requestSubmit(); else form.submit();
  };
  const later = () => { if (!desk()) return; clearTimeout(timer); timer = setTimeout(apply, 450); };

  /* Rubriques repliables */
  const closed = (() => { try { return JSON.parse((store && store.getItem(KEY + 'Closed')) || '[]'); } catch (_) { return []; } })();
  $$('fieldset.c-group', form).forEach((g, i) => {
    const lg = $('legend', g); if (!lg) return;
    const key = g.dataset.cGroup || 'g' + i;
    const body = document.createElement('div');
    body.className = 'lsl-cf__body';
    body.id = 'lsl-cf-b-' + key;
    Array.from(g.children).filter(c => c !== lg).forEach(c => body.append(c));
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lsl-cf__tog';
    btn.setAttribute('aria-controls', body.id);
    btn.innerHTML = `<span>${esc(lg.textContent.trim())}</span><em data-lsl-cf-gn hidden></em><i aria-hidden="true"></i>`;
    g.append(btn, body);
    const set = open => { g.classList.toggle('is-closed', !open); btn.setAttribute('aria-expanded', String(open)); };
    set(!closed.includes(key));
    btn.addEventListener('click', () => {
      const open = g.classList.contains('is-closed');
      set(open);
      const list = closed.filter(k => k !== key); if (!open) list.push(key);
      closed.length = 0; closed.push(...list);
      try { if (store) store.setItem(KEY + 'Closed', JSON.stringify(list)); } catch (_) {}
    });
    if ($('input[name="filter.v.availability"]', g)) g.classList.add('lsl-cf--avail');
    if (g.dataset.cGroup === 'usage') g.classList.add('lsl-cf--chips');
  });

  /* Personnages : recherche */
  const chars = $('fieldset[data-c-group="character"] .c-opts', form);
  if (chars) {
    const box = document.createElement('div');
    box.className = 'lsl-cf__find';
    box.innerHTML = '<input type="search" class="lsl-cf__search" placeholder="Chercher un personnage" aria-label="Chercher un personnage" autocomplete="off"><p class="lsl-cf__none" hidden>Aucun personnage à ce nom.</p>';
    chars.before(box);
    const q = $('input', box), none = $('.lsl-cf__none', box);
    q.addEventListener('input', () => {
      const v = norm(q.value.trim()); let n = 0;
      $$('.c-opt', chars).forEach(o => { const ok = !v || norm(o.textContent).includes(v); o.hidden = !ok; if (ok) n++; });
      none.hidden = n > 0;
    });
    q.addEventListener('keydown', e => { if (e.key === 'Enter') e.preventDefault(); });
  }

  /* Budget : tranches prêtes */
  if (price.gte && price.lte) {
    const R = [[0, 150, 'Moins de 150 €'], [150, 300, '150 à 300 €'], [300, 500, '300 à 500 €'], [500, '', '500 € et plus']];
    const box = document.createElement('div');
    box.className = 'lsl-cf__ranges';
    box.setAttribute('role', 'group');
    box.setAttribute('aria-label', 'Tranches de prix');
    box.innerHTML = R.map(r => `<button type="button" data-gte="${r[0]}" data-lte="${r[1]}" aria-pressed="false">${r[2]}</button>`).join('');
    price.gte.closest('.c-price').before(box);
    const cur = () => { const a = price.gte.value, b = price.lte.value; $$('button', box).forEach(x => x.setAttribute('aria-pressed', String(x.dataset.gte === (a || '0') && x.dataset.lte === b && (a || b) !== ''))); };
    box.addEventListener('click', e => {
      const b = e.target.closest('button'); if (!b) return;
      const on = b.getAttribute('aria-pressed') === 'true';
      price.gte.value = on || b.dataset.gte === '0' ? '' : b.dataset.gte;
      price.lte.value = on ? '' : b.dataset.lte;
      if (!on && b.dataset.gte === '0') price.gte.value = '';
      cur(); paint();
      if (desk()) apply();
    });
    cur();
  }

  /* Filtres choisis et compteurs */
  const label = i => { const l = i.closest('label'); const s = l && $('span', l); return (s ? s.textContent : i.value).trim(); };
  /* L'adresse fait foi au chargement : les cases des filtres en cours sont cochées tout de suite (une seule fois par case) */
  const sp = new URLSearchParams(location.search);
  const sync = () => $$('input[type="checkbox"]', form).forEach(i => {
    if (i.dataset.lslCfSync) return;
    i.dataset.lslCfSync = '1';
    if (!i.checked && sp.getAll(i.name).flatMap(v => v.split(',')).includes(i.value)) i.checked = true;
  });
  function paint() {
    sync();
    const on = $$('input[type="checkbox"]:checked', form);
    const items = on.map(i => ({ t: label(i), i }));
    const a = price.gte && price.gte.value, b = price.lte && price.lte.value;
    if (a || b) items.push({ t: a && b ? `${a} à ${b} €` : a ? `Dès ${a} €` : `Jusqu’à ${b} €`, price: true });
    active.innerHTML = items.map((x, k) => `<button type="button" class="lsl-cf__pill" data-k="${k}" aria-label="Retirer le filtre ${esc(x.t)}">${esc(x.t)}<i aria-hidden="true"></i></button>`).join('');
    active.hidden = !items.length;
    active._items = items;
    const n = $('[data-lsl-cf-n]', head); n.textContent = items.length; n.hidden = !items.length;
    const c = $('.lsl-cf__clear', head); if (c) c.hidden = !items.length;
    $$('fieldset.c-group', form).forEach(g => {
      const k = $$('input[type="checkbox"]:checked', g).length + ($('.c-price', g) && (a || b) ? 1 : 0);
      const em = $('[data-lsl-cf-gn]', g); if (em) { if (em.textContent !== String(k)) em.textContent = k; em.hidden = !k; }
    });
  }
  active.addEventListener('click', e => {
    const b = e.target.closest('.lsl-cf__pill'); if (!b) return;
    const x = (active._items || [])[+b.dataset.k]; if (!x) return;
    if (x.price) { price.gte.value = ''; price.lte.value = ''; } else x.i.checked = false;
    paint();
    if (desk()) apply();
  });
  form.addEventListener('change', e => {
    paint();
    if (e.target.matches('input[type="checkbox"]')) later();
    else if (e.target.matches('input[type="number"]')) later();
  });
  paint();
  /* Les filtres maison (utilisation, personnage) sont cochés après coup par lsl-collection-da.js */
  [300, 1200, 2500].forEach(t => setTimeout(paint, t));
  /* La liste des personnages et les nombres sont complétés après coup par lsl-collection-da.js */
  let raf = 0;
  new MutationObserver(() => { cancelAnimationFrame(raf); raf = requestAnimationFrame(paint); }).observe(form, { subtree: true, childList: true });
})();
